import { put, takeEvery } from 'redux-saga/effects'
import { START_REDUX_TEST , START_REDUX_TEST_REDUCERS } from '../actions'

export function* setAddPage({payload}) {
    yield put({ type: START_REDUX_TEST, payload })
}

export default function* testAddPage() {
    yield takeEvery(START_REDUX_TEST_REDUCERS, setAddPage)
  }